import type { ReactNode } from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

interface PublicLayoutProps {
  children: ReactNode;
  title?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export function PublicLayout({ children, title, maxWidth = 'sm' }: PublicLayoutProps) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)',
        py: 4,
      }}
    >
      <Container maxWidth={maxWidth}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              color: '#FFFFFF',
              fontWeight: 700,
              mb: 1,
            }}
          >
            M&A対応チェッカー
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            M&A包括分析システム
          </Typography>
        </Box>

        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 3,
          }}
        >
          {title && (
            <Typography
              variant="h5"
              component="h2"
              sx={{
                textAlign: 'center',
                mb: 3,
                fontWeight: 600,
              }}
            >
              {title}
            </Typography>
          )}
          {children}
        </Paper>
      </Container>
    </Box>
  );
}
